import React from 'react';
import styles from 'VStack.module.scss';

interface Props {
	children: React.ReactElement | React.ReactElement[];
	style?: React.CSSProperties;
}

const VStack: React.FC<Props> = ({ children, style }) => {
	return (
		<div className={styles.wrapper} style={style}>
			{React.Children.map(children, child => child)}
		</div>
	);
};

export default VStack;
